// Default imports
import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

// create context and client
export const TenantContext = createContext({
  tenant: null,
});

// export useContext hook
export const useTenant = () => useContext(TenantContext);

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const { session, supabase } = useAuth();

  useEffect(() => {
    if (session?.user?.user_metadata?.tenant) {
      setTenant(session.user.user_metadata.tenant);
    }
  }, [session]);

  const refreshSession = async () => {
    const { data, error } = await supabase.auth.refreshSession();
    if (error) {
      console.error("Error refreshing session:", error);
    } else {
      console.log("Session refreshed successfully");
      if (data.session?.user?.user_metadata?.tenant) {
        setTenant(data.session.user.user_metadata.tenant);
      }
    }
  };

  const signout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error("Error signing out:", error);
      } else {
        console.log("Signed out successfully");
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Unexpected error during sign out:", error);
    }
  };

  const value = {
    tenant,
    refreshSession,
  };

  if (tenant || !session) {
    return (
      <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
    );
  } else {
    return (
      <div className="text-center text-xs">
        <p className="font-medium mt-10 mb-10">
          Account not activated. Email marvin@rectanglehq.com if this persists.
        </p>
        <div className="space-x-3">
          <button className="text-slate-600" onClick={() => signout()}>
            Sign Out
          </button>
          <button className="text-slate-600" onClick={refreshSession}>
            Refresh Session
          </button>
        </div>
      </div>
    );
  }
};
